import React, { useState, useRef, useEffect } from 'react';
import EvaluationChecklistApp from '../ui-apps/evaluation-criteria-app-new/App';
import { useOutletContext } from "@remix-run/react";

interface OutletContext {
  auth: {
    isAuthenticated: boolean;
    user: any;
    displayPricingModal: boolean;
    isBeta: boolean;
  }
}

const EvaluationChecklist: React.FC = () => {
   const { auth } = useOutletContext<OutletContext>();
   const { isAuthenticated, user, displayPricingModal, isBeta } = auth;
   
  return (
    <>
      <EvaluationChecklistApp user={user} isAuthenticated={isAuthenticated} displayPricingModal={displayPricingModal} isBeta={isBeta}/>
    </>
  );
};

export default EvaluationChecklist;